module.exports = __webpack_public_path__ + "static/img/2.119d7e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/2.png
// module id = TxK9
// module chunks = 0